{
  "success": {
    "analyses/setMovable": "Analyse opdateret",
    "analyses/moveIntoPlan": "Analyse flyttet til plan",
    "analyses/remove": "Analyse fjernet fra plan",
    "analysisDefinitions/create": "Ny analysedefinition tilføjet",
    "analysisDefinitions/edit": "Analysedefinition redigeret",
    "analysisDefinitions/remove": "Analysedefinition slettet",
    "analysisDraft/create": "Nyt analyseudkast tilføjet",
    "analysisDraft/edit": "Analyseudkast redigeret",
    "samples/delete-unlocked": "Alle ikke-planlagte prøver slettet",
    "assets/remove": "Instrument slettet",
    "assets/create": "Nyt instrument tilføjet",
    "assets/edit": "Instrument redigeret",
    "competenceGroups/create": "Ny kompetencegruppe oprettet",
    "competenceGroups/edit": "Kompetencegruppe redigeret",
    "competenceGroups/remove": "Kompetencegruppe slettet",
    "iap/run": "IAP kørt",
    "iap/runFillInSamples": "Prøver udfyldt",
    "integrationSheets/createActionSheet": "Ark tilføjet",
    "integrationSheets/createProjectTemplateSheets": "Ark tilføjet",
    "integrationSheets/createSampleSheet": "Ark tilføjet",
    "integrationSheets/editActionSheet": "Ark redigeret",
    "integrationSheets/editProjectTemplateSheet": "Ark redigeret",
    "integrationSheets/editSampleSheet": "Ark redigeret",
    "integrationSheets/removeActionSheet": "Ark slettet",
    "integrationSheets/removeProjectTemplateSheet": "Ark slettet",
    "integrationSheets/removeSampleSheet": "Ark slettet",
    "integrationSheets/saveSapConversionSheet": "Projektimport-ark gemt",
    "members/create": "Medlem tilføjet",
    "members/createAsAdmin": "Medlem tilføjet",
    "members/edit": "Medlem redigeret",
    "members/archive": "Medlem arkiveret",
    "projectActions/editPlanned": "Projekthandling redigeret",
    "projectActions/move": "Projekthandling sat på skema",
    "projectActions/setMovable": "Projekthandling opdateret",
    "projectActions/setLocation": "Lokation opdateret",
    "projectActions/setLocationUnplanned": "Lokation opdateret",
    "projectActions/editUnplanned": "Ikke-planlagt projekthandling redigeret",
    "projectActions/removePlanned": "Projekt fjernet fra plan",
    "projects/create": "Nyt projekt tilføjet",
    "projects/edit": "Projekt opdateret",
    "projects/remove": "Projekt slettet",
    "projects/delete-unplanned": "Alle ikke-planlagte projekter slettet",
    "projects/lockProject": "Projekt låst",
    "projects/unlockProject": "Projekt låst op",
    "projectTemplates/create": "Ny projektskabelon oprettet",
    "projectTemplates/createDraft": "Nyt projektskabelonudkast oprettet",
    "projectTemplates/edit": "Projektskabelon redigeret",
    "projectTemplates/editDraft": "Projektskabelonudkast redigeret",
    "projectTemplates/remove": "Projektskabelon slettet",
    "whiteTasks/remove": "Opgave slettet",
    "whiteTasks/create": "Ny opgave tilføjet",
    "whiteTasks/edit": "Opgave redigeret",
    "whiteTasks/createRecurrence": "Gentagelse oprettet",
    "whiteTasks/removeRecurrence": "Gentagne opgaver fjernet",
    "teamStatus/start": "Simuleringstilstand aktiveret",
    "teamStatus/accept": "Ændringer fra simuleringstilstand anvendt",
    "teamStatus/discard": "Ændringer fra simuleringstilstand kasseret",
    "customers/addCustomer": "Kunde tilføjet",
    "customers/editCustomer": "Kunde redigeret",
    "customers/deleteCustomer": "Kunde slettet",
    "team/create-api-token": "API-nøgle oprettet",
    "team/delete-api-token": "API-nøgle slettet"
  },
  "error": {
    "analyses/remove/ERROR": "Kunne ikke fjerne analyse fra plan",
    "analysisDefinitions/create/ERROR": "Kunne ikke tilføje ny analysedefinition",
    "analysisDefinitions/remove/ERROR": "Kunne ikke slette analysedefinition",
    "assets/remove/ERROR": "Kunne ikke slette instrument",
    "assets/create/ERROR": "Kunne ikke tilføje instrument",
    "auth/login/ERROR": "Login mislykkedes",
    "competenceGroups/create/ERROR": "Kunne ikke oprette kompetencegruppe",
    "competenceGroups/remove/ERROR": "Kunne ikke slette kompetencegruppe",
    "iap/run/ERROR": "Kunne ikke køre IAP",
    "iap/runFillInSamples/ERROR": "Kunne ikke udfylde prøver",
    "integrationSheets/createActionSheet/ERROR": "Kunne ikke tilføje ark",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Kunne ikke tilføje ark",
    "integrationSheets/createSampleSheet/ERROR": "Kunne ikke tilføje ark",
    "integrationSheets/editActionSheet/ERROR": "Kunne ikke redigere ark",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Kunne ikke redigere ark",
    "integrationSheets/editSampleSheet/ERROR": "Kunne ikke redigere ark",
    "integrationSheets/removeActionSheet/ERROR": "Der opstod en fejl under sletning af ark",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Der opstod en fejl under sletning af ark",
    "integrationSheets/removeSampleSheet/ERROR": "Der opstod en fejl under sletning af ark",
    "loading/fetchAll/ERROR": "Indlæsning mislykkedes",
    "members/create/ERROR": "Kunne ikke tilføje medlem",
    "members/createAsAdmin/ERROR": "Kunne ikke tilføje medlem",
    "members/archive/ERROR": "Kunne ikke arkivere medlem",
    "projectActions/move/ERROR": "Kunne ikke flytte handling til skema",
    "projectActions/removePlanned/ERROR": "Kunne ikke fjerne handling fra plan",
    "projectActions/setLocation/ERROR": "Kunne ikke opdatere lokation",
    "projectActions/setLocationUnplanned/ERROR": "Kunne ikke opdatere lokation",
    "projects/create/ERROR": "Kunne ikke tilføje nyt projekt",
    "projects/remove/ERROR": "Kunne ikke slette projekt",
    "projects/delete-unplanned/ERROR": "Kunne ikke slette ikke-planlagte projekter",
    "projects/lockProject/ERROR": "Kunne ikke låse handlinger",
    "projectTemplates/create/ERROR": "Kunne ikke oprette ny projektskabelon",
    "projectTemplates/createDraft/ERROR": "Kunne ikke oprette nyt projektskabelonudkast",
    "projectTemplates/remove/ERROR": "Kunne ikke slette projektskabelon",
    "whiteTasks/remove/ERROR": "Kunne ikke slette opgave",
    "whiteTasks/create/ERROR": "Kunne ikke oprette",
    "teamStatus/start/ERROR": "Kunne ikke starte simuleringstilstand",
    "teamStatus/accept/ERROR": "Kunne ikke anvende ændringer fra simuleringstilstand",
    "teamStatus/discard/ERROR": "Kunne ikke kassere ændringer fra simuleringstilstand",
    "customers/deleteCustomer/ERROR": "Kunne ikke slette kunden",
    "customers/addCustomer/ERROR": "Kunne ikke tilføje kunden",
    "customers/editCustomer/ERROR": "Kunne ikke redigere kunden",
    "team/create-api-token/ERROR": "Kunne ikke oprette API-nøgle",
    "team/delete-api-token/ERROR": "Kunne ikke slette API-nøgle"
  },
  "adhoc": {
    "welcomeBack": "Velkommen tilbage!",
    "noSoundDetected": "Ingen lyd registreret. Prøv venligst igen.",
    "noMicrophoneDetected": "Ingen mikrofon fundet. Prøv venligst igen.",
    "iapRunning": "Vent venligst - IAP'en for dit hold kører",
    "failedDiscardNotLoggedOut": "Kunne ikke kassere ændringer. Du blev ikke logget ud!",
    "cannotDragRecurrentTask": "Du kan ikke trække og slippe en tilbagevendende grå opgave",
    "cannotMoveImportedTasks": "Du kan ikke flytte importerede opgaver",
    "noCheckboxesSelected": "Ingen afkrydsningsfelter valgt",
    "analysisUpdatedRefresh": "Analyse opdateret, opdater venligst siden",
    "analysisUpdatedByAnotherUser": "Analysen er blevet opdateret af en anden bruger, opdater venligst siden",
    "copiedToClipboard": "Kopieret til udklipsholder",
    "couldNotCopyToClipboard": "Kunne ikke kopiere til udklipsholder",
    "chooseFirstAction": "Vælg venligst den første {{itemType}}",
    "chooseSecondAction": "Vælg venligst den anden {{itemType}}",
    "chooseTwoDifferent": "Vælg venligst to forskellige {{itemType}}",
    "constraintConflicts": "Den begrænsning er i konflikt med eksisterende",
    "sampleCreated": "Prøve oprettet",
    "sampleDeleted": "Prøve slettet",
    "samplesUpdated": "Prøver opdateret",
    "sampleMarkedDone": "Prøve markeret som færdig",
    "memberPermissionsChanged": "Medlemsrettigheder ændret",
    "chooseUniqueName": "Vælg venligst et unikt navn",
    "fillRequiredFields": "Udfyld venligst de påkrævede felter",
    "couldNotDetermineSampleIdDone": "Kunne ikke bestemme prøve-id til at markere som færdig",
    "couldNotDetermineSampleIdDelete": "Kunne ikke bestemme prøve-id til sletning",
    "couldNotDetermineSampleIdDeleteMissing": "Kunne ikke bestemme prøve-id til sletning — data mangler. Tjek konsollen for detaljer.",
    "anErrorOccurred": "Der opstod en fejl",
    "selectFileBeforeSubmitting": "Vælg venligst mindst én fil før indsendelse",
    "helpPageUpdated": "Hjælpeside opdateret",
    "processingStarted": "Behandling startet",
    "failedLoadingIcalFiles": "Kunne ikke indlæse iCalendar-filer",
    "unsortBeforePasting": "Fjern venligst sorteringen af tabellen før du indsætter flere celler.",
    "fillAllRequiredFields": "Udfyld venligst alle påkrævede felter",
    "unsavedChangesConfirmLeave": "Du har ugemte ændringer. Tryk på tilbage-knappen igen for at bekræfte, at du vil forlade siden.",
    "provideSheetName": "Angiv venligst et arknavn",
    "sheetNameAlreadyExists": "Et ark med det navn eksisterer allerede",
    "provideSheetType": "Angiv venligst en arktype",
    "didNotSpellDeleteProperly": "Du stavede ikke DELETE korrekt",
    "domainMustStartWithAt": "Domænet skal starte med '@'",
    "fillOutRequiredFields": "Udfyld venligst de påkrævede felter",
    "selectValidDates": "Vælg venligst gyldige datoer",
    "noIapModeSelected": "Ingen IAP-tilstand valgt. Vælg venligst en tilstand.",
    "oneCollaboratorForWorkday": "Kun én samarbejdspartner kan vælges ved markering af hele arbejdsdagen",
    "fillRequiredDateTimeFields": "Udfyld venligst alle påkrævede dato- og tidsfelter",
    "endMustBeAfterStart": "Sluttidspunktet skal være efter starttidspunktet",
    "recurrencesCannotExceed365": "Antal gentagelser kan ikke være større end 365",
    "pleaseFillNumberAndInterval": "Udfyld venligst antal og interval for gentagelser",
    "pleaseFillNumberOfRecurrences": "Udfyld venligst antal gentagelser",
    "pleaseFillIntervalOfRecurrences": "Udfyld venligst interval for gentagelser",
    "pleaseFillAllPeriodFields": "Udfyld venligst alle periodefelter",
    "pleaseSelectReportType": "Vælg venligst mindst én rapporttype",
    "reportEmptyInInterval": "{{fileName}} er tom i det valgte interval",
    "noSoundDetected": "Ingen lyd registreret. Pr\u00f8v venligst igen.",
    "noMicrophoneDetected": "Ingen mikrofon fundet. Pr\u00f8v venligst igen.",
    "promptTooLong": "Prompt for lang (maks. er 1200 tegn)",
    "nameTooLong": "Navn for langt (maks. er 100 tegn)"
  }
}
